var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F53635"
    },
    d: "M372.832,0H57.642L35.137,255.998L57.642,512h315.189c18.567,0,33.758-15.191,33.758-33.758V33.758 C406.59,15.191,391.399,0,372.832,0z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD691"
    },
    points: "476.863,81.807 499.369,135.944 476.863,158.45 454.358,135.944 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F53635"
    },
    d: "M499.369,472.615v22.505c0,9.284-7.596,16.879-16.879,16.879h-11.253 c-9.284,0-16.879-7.596-16.879-16.879v-22.505l22.505-22.505L499.369,472.615z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 454.352,
    y: 135.944,
    style: {
      fill: "#FAB43E"
    },
    width: 45.011,
    height: 336.671
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.406,
    y: 78.769,
    style: {
      fill: "#FDF3C2"
    },
    width: 191.409,
    height: 101.275
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.631,
    style: {
      fill: "#C40200"
    },
    width: 45.011,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F53635"
    },
    d: "M294.066,120.963h-123.9c-4.661,0-8.44-3.778-8.44-8.44s3.779-8.44,8.44-8.44h123.898 c4.661,0,8.44,3.778,8.44,8.44S298.727,120.963,294.066,120.963z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F53635"
    },
    d: "M294.066,154.721h-123.9c-4.661,0-8.44-3.778-8.44-8.44s3.779-8.44,8.44-8.44h123.898 c4.661,0,8.44,3.778,8.44,8.44C302.504,150.943,298.727,154.721,294.066,154.721z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotebook);
export default __webpack_public_path__ + "static/media/notebook.c61c74698a4328744dc9dbe059d1f491.svg";
export { ForwardRef as ReactComponent };